<template>
    <div>
        <base-modal :isOpen="value" :title="title" @close="close">
            <template #body>
                <div class="flex flex-col">
                    <label for="client">
                        {{ $t('client') | capitalize }}
                    </label>
                    <v-select :options="clients" class="w-full custom-select" label="client_name" :reduce="(item) => item.client_id" v-model="clientId"></v-select>
                </div>

                 <div class="flex flex-col mt-4">
                    <label for="client">
                        {{ $t('periods') | capitalize }}
                    </label>
                    <v-select :options="clients" class="w-full custom-select" label="client_name" :reduce="(item) => item.client_id" v-model="clientId"></v-select>
                </div>

                <div class="flex flex-col mt-4">
                    <label for="hours">
                        {{ $t('hours') | capitalize }}
                    </label>
                    <vs-input class="w-full" type="number" v-model="hours"/>
                </div>
                 <div class="flex flex-col mt-4">
                      <vs-checkbox color="success" v-model="checkAddExpenses">{{ $t('add_expenses') | capitalize }}</vs-checkbox>
                </div>
                <div class="flex flex-col mt-4">
                      <upload-file />
                </div>

                
                <vs-alert :active="alert" class="mt-4" color="warning">
                    Please enter a valid number of hours.
                </vs-alert>
            </template>
            <template #footer>
                <div class="flex gap-4">
                    <vs-button color="danger" icon="close" type="flat" @click="close">
                        {{ $t('close') | upperCase }}
                    </vs-button>
                    <vs-button color="success" icon="save" type="flat" @click="save">
                        {{ $t('save') | upperCase }}
                    </vs-button>
                </div>

            </template>
        </base-modal>
    </div>

</template>

<script setup>
import { ref, watch, computed } from 'vue'
import BaseModal from '@/views/app/components/BaseModal.vue'
import vSelect from 'vue-select'
import UploadFile from '@/views/app/components/UploadFile.vue'
import { capitalize } from '../../../../../../utils/helpers'

const props = defineProps({
    value: { type: Boolean, default: false },
    title: { type: String, default: 'Title' },
    clients: { type:Array, default: () => ([])},
    periods: { type:Array, default: () => ([])}
})

const emit = defineEmits(['click', 'add'])

const hours = ref(1)
const checkAddExpenses = ref(false)
const clientId = ref('')

watch(() => props.value, (newValue) => {
    if (newValue) {
        hours.value = 1
    }
})

const alert = computed(() => hours.value <= 0 && hours.value != '')

const close = () => {
    emit('input', false)
}

const validateHours = () => {
    if(hours.value <= 0){

    }
    return false
}

const save = () => {
    const payload = {
        clientId:clientId.value,
        hours:hours.value,
        addExpenses:checkAddExpenses.value
    }
    emit('add',payload)
}

</script>

<style scoped>
::v-deep(.custom-select .vs__dropdown-menu) {
  max-height: 100px;
}
</style>